export const getHasWaterEvents = ({
  hasRain,
  emitterData,
}: {
  hasRain: boolean
  emitterData: { [irrigationZoneEmitterId: string]: unknown[] }
}) => hasRain || Object.values(emitterData).some((events) => events.length > 0)
